import { render, staticRenderFns } from "./StatisticTopSellProduct.vue?vue&type=template&id=670f9081&scoped=true"
import script from "./StatisticTopSellProduct.vue?vue&type=script&lang=js"
export * from "./StatisticTopSellProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670f9081",
  null
  
)

export default component.exports